import { English, French } from '../languages';

export const SUPPORTED_LANGUAGES = {
  en: {
    code: 'en',
    name: 'English',
    messages: English,
    flag: '🇺🇸',
    direction: 'ltr',
  },
  fr: {
    code: 'fr',
    name: 'Français',
    messages: French,
    flag: '🇫🇷',
    direction: 'ltr',
  },
};

export const DEFAULT_LANGUAGE = 'en';
export const FALLBACK_LANGUAGE = 'en';

export const LANGUAGE_CODES = Object.keys(SUPPORTED_LANGUAGES);
export const LANGUAGE_OPTIONS = Object.values(SUPPORTED_LANGUAGES);

export const getLanguageByCode = (code) => {
  return SUPPORTED_LANGUAGES[code] || SUPPORTED_LANGUAGES[FALLBACK_LANGUAGE];
};

export const isLanguageSupported = (code) => {
  return LANGUAGE_CODES.includes(code);
};

export const getBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  
  for (const code of LANGUAGE_CODES) {
    if (browserLang.toLowerCase().startsWith(code.toLowerCase())) {
      return code;
    }
  }
  
  return DEFAULT_LANGUAGE;
};

export const getLanguageFromURL = (pathname) => {
  if (pathname.startsWith('/fr/')) return 'fr';
  if (pathname.startsWith('/en/')) return 'en';
  
  const frenchPaths = ['/a-propos', '/actualites', '/produits', '/fr/contact', '/fr/services'];
  if (frenchPaths.some(path => pathname === path || pathname.startsWith(path))) {
    return 'fr';
  }
  
  const englishPaths = ['/about', '/news', '/products', '/contact', '/services'];
  if (englishPaths.some(path => pathname === path || pathname.startsWith(path))) {
    return 'en';
  }
  
  return null;
};